import { catalogueDescription, catalogueLabel } from '@/features/common/useExternalCatalogues';
import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { useTranslation } from '@/i18n/useTranslation';
import type { LibraryExternalCataloguesProps } from '@/features/publicsite/types/registry/LibraryExternalCataloguesProps';

/** The library's second group: the international catalogues it links out to, one card each. */
export function LibraryExternalCatalogues({ catalogues }: LibraryExternalCataloguesProps) {
  const { t, language } = useTranslation(publicRegistry);
  return (
    <>
      <div className="section-head library-external">
        <div>
          <span className="eyebrow">{t('libraryExternalEyebrow')}</span>
          <h2 className="library-external__heading">{t('libraryExternalHeading')}</h2>
        </div>
      </div>
      <div className="card-grid">
        {catalogues.map(({ catalogue, href }) => (
          <a className="card" key={catalogue.code} href={href} rel="noopener" target="_blank">
            <h3>{catalogueLabel(catalogue, language)}</h3>
            <p>{catalogueDescription(catalogue, language)}</p>
            <span className="card__foot">
              <span className="card__count">
                {t('libraryExternalCta', { name: catalogueLabel(catalogue, language) })}
              </span>
              <span className="card__arrow">→</span>
            </span>
          </a>
        ))}
      </div>
    </>
  );
}
